import logo from "../../assets/images/myanwan/logo.png";
const Header = () => {
  return (
    <div className="bg-black">
      <div className="max-w-6xl mx-auto px-5 py-5">
        <div className="w-[50px] aspect-square overflow-hidden">
          <img
            src={logo}
            alt="Myan WEn logo"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
